import { Typography } from '@/components/atoms';
import styled from 'styled-components';
import Icon3dview from '../../../public/asset/3dview.svg';
import { useTranslation } from 'next-i18next';

const Container = styled.div`
  position: relative;
  padding: 8px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    margin-right: 8px;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    justify-content: flex-start;
  }
`;

const TypoContainer = styled.div`
  text-align: left;
`;

const CustomTypo = styled(Typography)`
  color: ${props => props.theme.paletteDefault.primary.main};
`;

const Message3dView = () => {
  const { t } = useTranslation(['product']);
  return (
    <Container>
      <Icon3dview />
      <TypoContainer>
        <CustomTypo datatype="body_1" className="smalltitle">
          {t('product:new-feauture')}
        </CustomTypo>
        <CustomTypo datatype="body_1">
          {t('product:view-product-3d-1')}
        </CustomTypo>
      </TypoContainer>
    </Container>
  );
};

export default Message3dView;
